<template>
  <el-card class="seedling">
    <el-form class="global-form2" :model="formData" ref="form" :rules="rules" label-width="120px">
      <el-form-item label="考核对象" prop="resultTitle">
        <el-input v-model="formData.resultTitle" placeholder="请输入考核对象"></el-input>
      </el-form-item>
      <el-form-item label="考核日期" prop="resultDate">
        <el-date-picker class="picker" v-model="formData.resultDate" type="date" placeholder="考核日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="考核工单" prop="issueIds">
        <div class="mb15">
          <el-button type="primary" @click="showDialog">选择考核工单</el-button>
          <el-button @click="clearIssueList">全部清除</el-button>
        </div>
        <el-table class="global-table" v-loading="loading" :data="issueList">
          <el-table-column label="所属项目" show-overflow-tooltip prop="projectName"></el-table-column>
          <el-table-column label="考核大项" show-overflow-tooltip prop="assessmentTypeName"></el-table-column>
          <el-table-column label="考核细则编号" show-overflow-tooltip prop="scoreNo"></el-table-column>
          <el-table-column label="工单详情" show-overflow-tooltip prop="issueContent"></el-table-column>
          <el-table-column label="提交时间" show-overflow-tooltip prop="ctime"></el-table-column>
          <el-table-column label="当前节点" show-overflow-tooltip prop="taskName"></el-table-column>
          <el-table-column label="扣分情况" show-overflow-tooltip prop="score"></el-table-column>
          <el-table-column label="工单状态" show-overflow-tooltip prop="issueStatus">
            <template v-slot="{ row }">{{ orderStatusMap.get(row.issueStatus) }}</template>
          </el-table-column>
          <el-table-column label="已耗时" show-overflow-tooltip prop="time"></el-table-column>
          <el-table-column label="操作" width="200px" fixed="right">
            <template v-slot="{ row, $index }">
              <el-button type="text" v-if="row.processId" @click="showProcess(row)">查看</el-button>
              <el-button type="text" @click="deleteIssue($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="得分合计">
        {{ totalScore }}
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>

    <el-dialog :visible.sync="dialogVisible" width="1200px" @open="onOpen" title="考核工单选择" :close-on-click-modal="false">
      <el-form inline ref="searchForm">
        <el-form-item>
          <el-select v-model="searchForm.projectId" clearable filterable placeholder="请选择所属项目">
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.assessmentType" placeholder="请选择考核大项" clearable>
            <el-option v-for="(item, index) in assessmentTypeList" :label="item.dicValue" :value="item.dicCode"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.scoreNo" size="small" placeholder="请输入考核细则编号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.issueStatus" placeholder="请选择工单状态" clearable>
            <el-option v-for="([key, value], index) of orderStatusMap" :label="value" :value="key"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker class="picker" v-model="datePicker" type="daterange" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table class="global-table" ref="table" v-loading="loading" row-key="issueId" :data="tableData">
        <el-table-column type="selection" reserve-selection :selectable="selectable"></el-table-column>
        <el-table-column label="所属项目" show-overflow-tooltip prop="projectName"></el-table-column>
        <el-table-column label="考核大项" show-overflow-tooltip prop="assessmentTypeName"></el-table-column>
        <el-table-column label="考核细则编号" show-overflow-tooltip prop="scoreNo"></el-table-column>
        <el-table-column label="工单详情" show-overflow-tooltip prop="issueContent"></el-table-column>
        <el-table-column label="提交时间" show-overflow-tooltip prop="ctime"></el-table-column>
        <el-table-column label="当前节点" show-overflow-tooltip prop="taskName"></el-table-column>
        <el-table-column label="工单状态" show-overflow-tooltip prop="issueStatus">
          <template v-slot="{ row }">{{ orderStatusMap.get(row.issueStatus) }}</template>
        </el-table-column>
        <el-table-column label="已耗时" show-overflow-tooltip prop="time"></el-table-column>
      </el-table>
      <global-pagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
        :page-size.sync="size" :total="total">
      </global-pagination>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-drawer :size="'500px'" direction="rtl" title="审批详情" :visible.sync="processVisible">
      <instance-preview v-if="processVisible" :instance-id="selectInstance.instanceId"
        @handler-after="handlerAfter"></instance-preview>
    </el-drawer>
  </el-card>
</template>

<script>
import { orderStatus } from '@/utils/dict'
import InstancePreview from '@/views/wflow/workspace/approval/ProcessInstancePreview'
export default {
  name: 'AssessmentRulesAdd',
  components: { InstancePreview },
  data() {
    return {
      dialogVisible: false,
      processVisible: false,
      selectInstance: {
        instanceId: '',
        nodeId: ''
      },
      loading: false,
      formData: {
        resultTitle: '', // 考核结果对象
        resultDate: '', // 考核结果日期
        resultScore: '', // 考核结果得分
        issueIds: [] // 考核问题ID集合
      },
      orderStatusMap: orderStatus,
      assessmentTypeList: [],
      issueList: [],
      tableData: [],
      page: 1,
      size: 5,
      total: 0,
      datePicker: [],
      searchForm: {
        projectId: '', // 项目Id
        assessmentType: '', // 考核项分类(字典assessmentType)
        scoreNo: '', // 扣分编号
        issueStatus: '', // 问题状态1审批进行中2审批通过3审批被驳回4审批被撤销5审批结束
        startTime: '',
        endTime: ''
      },
      rules: {
        resultTitle: [
          { required: true, message: '请输入考核对象' }
        ],
        resultDate: [
          { required: true, message: '请选择考核日期' }
        ],
        issueIds: [
          { required: true, type: 'array', message: '请添加考核工单' }
        ]
      }
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList || []
    },
    totalScore() {
      if (!this.issueList.length) {
        return '--'
      }
      return 100 - this.issueList.reduce((prev, curr) => {
        return parseFloat(prev) + parseFloat(curr.score || 0)
      }, 0)
    }
  },
  created() {
    this.loadDict()
  },
  methods: {
    selectable(row) {
      return !this.formData.issueIds.includes(row.issueId)
    },
    onOpen() {
      if (this.issueList && this.issueList.length) {
        this.issueList.forEach(item => {
          this.$refs.table.toggleRowSelection(item, true)
        })
      }
      this.onSearch()
    },
    confirm() {
      const selection = this.$refs.table.selection
      if (selection.length > 0) {
        this.issueList = selection
        this.formData.issueIds = selection.map(item => item.issueId)
        this.$refs.table.clearSelection()
        this.dialogVisible = false
      } else {
        this.$message.warning('请选择考核工单')
      }
    },
    deleteIssue(index) {
      this.issueList.splice(index, 1)
      this.formData.issueIds.splice(index, 1)
    },
    showDialog() {
      this.dialogVisible = true
      this.$nextTick(() => {
      })
    },
    clearIssueList() {
      this.issueList = []
      this.formData.issueIds = []
    },
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'assessmentType' }).then(res => {
        this.assessmentTypeList = res.assessmentType || []
      })
    },
    loadData() {
      this.loading = true
      return this.$axios.get(this.$apis.assessmentScore.selectLcAssessmentIssueByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then((res) => {
        this.tableData = res.list || []
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      return this.loadData()
    },
    dateChange(val) {
      if (val) {
        this.searchForm.startTime = val[0]
        this.searchForm.endTime = val[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formData.resultScore = this.totalScore
          this.$axios.post(this.$apis.assessmentScore.insertAssessmentResult, this.formData).then(() => {
            this.$message.success('保存成功')
            this.$router.back()
          })
        }
      })
    },
    showProcess(row) {
      this.processVisible = true
      this.selectInstance = {
        instanceId: row.processId,
        nodeId: row.nodeId
      }
    },
    handlerAfter() {
      this.processVisible = false
    }
  }
}
</script>

<style scoped lang="scss"></style>
